export default [
  {
    path: "/direct-login",
    name: "direct-login",
    component: () => import("./views/DirectLoginView.vue")
  }
];
